import { IPaymentRequest } from "@rentiohq/shared-frontend/dist/types/paymentRequest.types";
import { enqueueSnackbar } from "@rentiohq/web-shared-next/dist/utils/snackbar";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  getPlannedCollectionMessage,
  isPlannedCollection,
} from "../../utils/paymentRequest.utils";
import { PAYMENTS_ROUTE } from "./Payments.utils";

// The lists offer no manual payment for a planned collection, which direct
// debit already collects, so every payment-flow screen is reachable for one by
// URL only. Each of them sends the tenant back to the payments overview with
// the collection date instead. The return value lets a screen skip its own
// payment calls while the redirect is on its way.
export const useRedirectIfPlannedCollection = (
  paymentRequest?: IPaymentRequest,
) => {
  const navigate = useNavigate();

  const isPlanned = paymentRequest
    ? isPlannedCollection(paymentRequest)
    : false;

  React.useEffect(() => {
    if (!paymentRequest || !isPlannedCollection(paymentRequest)) {
      return;
    }

    enqueueSnackbar({
      message: getPlannedCollectionMessage(paymentRequest),
      variant: "info",
    });
    navigate(PAYMENTS_ROUTE);
  }, [paymentRequest, navigate]);

  return isPlanned;
};
